function Hero() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById("pricing");
    pricingSection?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="py-12 sm:py-20 lg:py-28 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Текстовый блок */}
          <div className="space-y-6 sm:space-y-8">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-black leading-tight uppercase tracking-tight">НАВЕДИ ПОРЯДОК В ГОЛОВЕ! НАЧНИ ЗАРАБАТЫВАТЬ В 2 РАЗА БОЛЬШЕ🔥

            </h1>
            <p className="text-lg sm:text-xl text-gray-700 leading-relaxed font-normal">
              Хватит прятаться за "хочу расслабиться". Фриланс и умственный труд — это жесткая дисциплина. 
              Получи Excel-планер, который структурирует хаос и заставит тебя выполнять задачи в срок.
            </p>
            <button
              onClick={scrollToPricing}
              className="bg-[#F45B3C] text-white font-bold px-8 sm:px-12 py-4 sm:py-5 rounded-lg text-lg sm:text-xl hover:bg-[#D32F2F] transition-all duration-200 hover:shadow-2xl hover:-translate-y-1 shadow-lg w-full sm:w-auto">ЗАБРАТЬ СИСТЕМУ


            </button>
          </div>

          {/* Видео планера */}
          <div className="relative overflow-hidden rounded-lg">
            <video
              src="https://static.lumi.new/material/17/17dd250517de1adb004099feddd63ca6.mov"
              autoPlay
              loop
              muted
              playsInline
              className="w-full rounded-lg shadow-2xl border-4 border-gray-200 transition-transform duration-300 hover:scale-105" />

          </div>
        </div>
      </div>
    </section>);

}

export default Hero;